export const SPINNER_STRINGS = {
  otp: {
    existingOffer: "Existing saved offer found for this number.",
    mockHelp: "Mock OTP sent. Use 123456 to verify.",
    invalidNumber: "Enter a valid mobile number to continue.",
    sendFirst: "Send OTP first.",
    verifySuccess: "Mobile number verified. You can now spin the wheel.",
    verifyMockError: "Incorrect OTP. Use 123456 for this mocked dev flow.",
    verifyApiError: "Incorrect OTP. Please try again.",
    sendApiError: "Failed to send OTP. Please try again.",
    sendApiUnavailable: "Unable to send OTP right now. Please try again.",
    verifyApiUnavailable: "Unable to verify OTP right now. Please try again.",
    otpSentSuccess: "OTP sent successfully.",
  },
  spinner: {
    noOffers: "No active offers available for this service.",
    noWinner: "Could not pick an offer.",
    saveError: "Offer selected, but failed to save spin result.",
    mismatchTitle: "Saved offer could not be matched to the current campaign.",
    mismatchMessage:
      "A previously saved offer exists, but the current offer set has changed. Please contact support.",
  },
  completion: {
    title: "You unlocked an offer",
    heading: "A little celebration, just for you",
    finalOffer: "Final offer",
    percentageBadgeSuffix: "off",
    journeyComplete: "Your reward is ready to be used on checkout.",
    savedPunjabi: "ਆਫਰ ਸੇਵ ਹੋ ਗਿਆ — ਹੁਣ ਮਜ਼ੇ ਨਾਲ ਬੁਕ ਕਰੋ.",
    existingPunjabi: "ਆਫਰ ਪਹਿਲਾਂ ਹੀ ਸੇਵ ਹੈ — ਹੁਣ ਮਜ਼ੇ ਨਾਲ ਬੁਕ ਕਰੋ.",
    saveSuccess: "Saved to your number successfully.",
    existingLoaded: "Your previously unlocked reward is ready.",
    done: "Done",
  },
  actions: {
    sendOtp: "Send OTP",
    resendOtp: "Resend",
    verify: "Verify",
    checking: "Checking...",
    verifyToContinue: "Verify mobile number to continue",
    spinning: "Spinning...",
    revealed: "Offer revealed",
    alreadyUnlocked: "Offer already unlocked",
    saveInProgress: "Saving offer...",
    spinToReveal: "Spin to reveal offer",
  },
};